import React from 'react';

import ZeroErrorState from '../Util/ZeroErrorState/ZeroErrorState';

import Button from '@material-ui/core/Button';

import './404.css';

class PageMiss extends React.Component {
 constructor(props) {
  super(props);
  this.state = {};
 }

 componentDidMount() {}

 handleHomeClick = () => {
  this.props.history.push('/');
 };

 render = () => {
  return (
   <React.Fragment>
    <div className="loader-container">
     <div style={{ textAlign: 'center' }}>
      <ZeroErrorState />
      <div className="home-page-text">The Page you are looking for is missing. Please click on the button to reach HOME.</div>
      <Button color="primary" variant="contained" onClick={this.handleHomeClick}>
       Home
      </Button>
     </div>
    </div>
   </React.Fragment>
  );
 };
}

export default PageMiss;
